module.exports = __webpack_public_path__ + "components/flag/static/square/mx-55cf561b56b820b9345e41bc2872e66e.svg";